import { environment } from '@curbnturf/environment';

/**
 * Local copy of @curbnturf/entities' BASE_API_URL — same value, sourced
 * directly from cnt-landing's own environment (the pattern already used by
 * TripBackendService) so cnt-landing's own services/interceptors don't need
 * the full entities domain-model import just for one string constant.
 */
export const BASE_API_URL = `${environment.apiUrl}/api/v1/`;

/**
 * Local copies of @curbnturf/entities' SEARCH_API_URL / BOONDOCK_SEARCH_API_URL —
 * same values, sourced directly from cnt-landing's own environment. Used by
 * LiveSearchApiService, same rationale as BASE_API_URL above.
 */
export const SEARCH_API_URL = environment.searchApiUrl;
export const BOONDOCK_SEARCH_API_URL = environment.boondockSearchApiUrl;

/**
 * Date-filtered private-listing search — the NestJS server's own
 * `listing-search` endpoint (real listing/site/reservation tables, already
 * availability-filtered), not the flattened search_listing table `SEARCH_API_URL`
 * points at. Used by LiveSearchApiService.findAvailable() whenever a date
 * range is active, in place of the per-listing calendar fan-out.
 */
export const AVAILABLE_SEARCH_API_URL = `${BASE_API_URL}listing-search`;

/**
 * Local copy of @curbnturf/entities' CONVERGE_GET_TOKEN_URL — same value,
 * sourced directly from cnt-landing's own environment. Used by
 * CreditCardApiService, same rationale as BASE_API_URL above.
 */
export const CONVERGE_GET_TOKEN_URL = environment.convergeGetTokenUrl;

/**
 * Narrow structural slice of @curbnturf/entities' IUser — only the fields
 * the JWT interceptor actually reads. Every IUser field is optional, so this
 * is freely assignable to/from the real IUser wherever the two types meet.
 */
export interface IAuthTokenUser {
  authExpires?: number;
  authIdToken?: string;
}
